/**
 * perk-gate — карточка платного результата: что он даёт, чем за него платят.
 *
 * ПОВОД (замеры 16.09.2026, 21 день, RU). Четыре документа сайта продавались
 * четырьмя разными карточками с четырьмя разными правилами, и ни одна из них
 * не работала: /iq-test — 12 299 показов оффера, 53 нажатия, 6 оплат;
 * /english-level-test — 13 567 результатов, 12 нажатий по цене, 6 документов.
 * При этом 12 291 зритель из 12 299 на IQ — НЕ вошедшие, а Премиум-касса с
 * этих двух страниц закрывается в 0.5 % (397 открытий → 2 активации), тогда
 * как денежная дверь на клик — в 25 %.
 *
 * Отсюда устройство карточки, и каждая его часть — следствие числа:
 *
 *   • План — заголовком, деньги — ВТОРОЙ СТРОКОЙ, а не за кликом. Прятать
 *     дверь с конверсией 25 % ради двери с 0.5 % было бы разменом не в ту
 *     сторону; «изначально видно, что доступно для Премиума» при этом
 *     выполняется (решение Фарида 16.09).
 *   • Состояние решает СЕРВЕР целиком (/api/perk/{perk}/state). Страница не
 *     вправе решать «Премиум ли он» по разметке: гостевая копия из PageCache
 *     приезжает вошедшему (класс auth_stale), и карточка соврала бы про цену.
 *   • Денежную дверь рисует НЕ этот модуль: ссылка с data-tmb-doc уходит в
 *     token-wall.js, где уже живут гостевая почта, согласия, СБП и
 *     предзагрузка платёжного поля. Вторая копия этого разошлась бы за месяц.
 *
 * Тул подключается двумя вещами:
 *   <x-perk-gate perk="iq_report" .../>  — место и тексты;
 *   window.__perkGate.register('iq_report', { park, issue, onIssued })
 *       park()   → Promise<{ref, token, name}>  отложить прогон (или вернуть уже отложенный)
 *       issue()  → Promise<{ok, ...}>           выдать документ (бесплатно/за токены)
 *       onIssued(res)                            показать результат на странице
 */
(function () {
    'use strict';

    var HOSTS = [];          // смонтированные карточки
    var HANDLERS = {};       // perk → {park, issue, onIssued}

    function T(host, key, fallback) {
        var v = host.getAttribute('data-t-' + key);
        return (v === null || v === '') ? (fallback || '') : v;
    }

    function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    function fmt(tpl, vars) {
        return String(tpl).replace(/:([a-z_]+)/g, function (m, k) {
            return Object.prototype.hasOwnProperty.call(vars, k) ? vars[k] : m;
        });
    }

    function num(n) {
        // Разряды пробелом — как везде на сайте; Intl есть во всех живых браузерах.
        try { return Number(n).toLocaleString(window.__LOCALE || 'ru'); } catch (e) { return String(n); }
    }

    function ev(host, stage, extra) {
        try {
            var p = Object.assign({ perk: host.getAttribute('data-perk') }, extra || {});
            if (window.__aeFunnel) window.__aeFunnel('perk_' + stage, p);
        } catch (e) { /* телеметрия никогда не ломает карточку */ }
    }

    /* ── состояние с сервера ─────────────────────────────────────────────── */

    function fetchState(host) {
        var perk = host.getAttribute('data-perk');
        var ctx  = host.__ctx || {};
        var q = '?locale=' + encodeURIComponent(window.__LOCALE || 'en');
        if (ctx.ref)   q += '&ref=' + encodeURIComponent(ctx.ref);
        if (ctx.token) q += '&token=' + encodeURIComponent(ctx.token);
        if (ctx.name)  q += '&name=' + encodeURIComponent(ctx.name);

        return fetch('/api/perk/' + encodeURIComponent(perk) + '/state' + q, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
        }).then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
    }

    /* ── отрисовка ───────────────────────────────────────────────────────── */

    function render(host, st) {
        if (!st) { host.innerHTML = ''; host.hidden = true; return; }

        /* Ответ состояния, запрошенный ещё БЕЗ номера прогона (монтаж,
         * объявление обработчиков) и пришедший ПОСЛЕ откладывания, перерисовал
         * бы денежную строку пустой — а откладывание закэшировано, и номер
         * больше не лёг бы ни на одну ссылку: «оплатить» уходило в кассу без
         * прогона (422 no_run) до перезагрузки. Номер помнится на эпоху
         * результата; сброс контекста его забывает (forgetPurpose). */
        if (!st.purpose && host.__purpose && host.__purposeEpoch === (host.__epoch || 0)) {
            st.purpose = host.__purpose;
        } else if (st.purpose && host.__purpose && host.__purposeEpoch === (host.__epoch || 0)) {
            // Свежее назначение той же эпохи (например, вписали имя) — помним его.
            host.__purpose = st.purpose;
        }

        host.__state = st;
        host.hidden = false;

        var title = T(host, 'title');
        var desc  = T(host, 'desc');
        var item  = T(host, 'item', title);

        var body = '<div class="pg-t">' + esc(title) + '</div>'
                 + (desc ? '<p class="pg-d">' + esc(desc) + '</p>' : '');

        if (st.state === 'premium_free') {
            body += '<button type="button" class="pg-btn" data-pg-free>' + esc(T(host, 'cta_get')) + '</button>';
            /* Остаток печатаем ТОЛЬКО когда он конечный: «осталось
             * 9223372036854775807» у админа — не щедрость, а видимая поломка,
             * поэтому сервер отдаёт для него null. */
            body += '<div class="pg-incl">'
                  + esc(st.unlimited || st.free_left === null
                        ? T(host, 'included')
                        : fmt(T(host, 'left'), { n: num(st.free_left) }))
                  + '</div>';

        } else if (st.state === 'premium_used' || st.state === 'premium_used_low') {
            /* У израсходованного перка ДРУГОЙ заголовок: это другая покупка, и
             * одинаковая шапка над разной ценой читается как ошибка. */
            body = '<div class="pg-t">' + esc(T(host, 'title_more', title)) + '</div>'
                 + '<p class="pg-d">' + esc(
                       st.used_at
                           ? fmt(T(host, 'used_on'), { date: dateOf(st.used_at) })
                           : desc
                   ) + '</p>';

            if (st.state === 'premium_used') {
                body += '<button type="button" class="pg-btn pg-ghost" data-pg-tokens>'
                      + esc(fmt(T(host, 'spend'), { n: num(st.tokens) })) + '</button>'
                      + '<div class="pg-bal">' + esc(fmt(T(host, 'balance'), { n: num(st.balance) })) + '</div>';
            } else if (T(host, 'store_url')) {
                // Токенов не хватает — дверь всё равно обязана быть.
                body += '<a class="pg-btn pg-ghost" href="' + esc(T(host, 'store_url')) + '">'
                      + esc(T(host, 'topup')) + '</a>'
                      + '<div class="pg-bal">' + esc(fmt(T(host, 'balance'), { n: num(st.balance) })) + '</div>';
            } else if (st.price_rub) {
                /* ⚠️ Магазина нет — но и `href="#"` рисовать нельзя: мёртвая
                 * кнопка хуже её отсутствия, потому что выглядит рабочей.
                 * Остаётся денежная дверь, и она становится главной. */
                body += '<div class="pg-bal">' + esc(fmt(T(host, 'balance'), { n: num(st.balance) })) + '</div>';
            } else {
                body += '<div class="pg-bal">' + esc(fmt(T(host, 'balance'), { n: num(st.balance) })) + '</div>';
            }
            if (st.price_rub) {
                body += moneyLine(host, st, T(host, 'or_money'));
            }

        } else {
            // guest / free_account — план заголовком, деньги второй строкой.
            body += '<button type="button" class="pg-btn" data-pg-premium>' + esc(T(host, 'cta_premium')) + '</button>';
            /* ⚠️ Вторая строка обязана быть В КАЖДОМ состоянии. Рублёвой двери
             * нет на восьми интернациональных локалях, и без запасных веток у
             * вошедшего без плана оставалось бы пустое место вместо покупки —
             * тот самый класс «половина дверей», из-за которого тул выглядит
             * исправным и не продаёт. */
            if (st.price_rub) {
                body += moneyLine(host, st, T(host, 'only_this'));
            } else if (st.can_tokens) {
                body += '<button type="button" class="pg-second pg-as-link" data-pg-tokens>'
                      + esc(fmt(T(host, 'or_tokens'), { n: num(st.tokens) })) + '</button>';
            } else if (st.state === 'guest') {
                body += '<a class="pg-second" href="' + esc(T(host, 'login_url') || '/login') + '">'
                      + esc(T(host, 'login')) + '</a>';
            } else if (T(host, 'store_url')) {
                body += '<a class="pg-second" href="' + esc(T(host, 'store_url')) + '">'
                      + esc(T(host, 'topup')) + '</a>';
            }
        }

        host.innerHTML = '<div class="pg-card">' + body + '</div>';
        wire(host, st);
        shownOnce(host, st);
    }

    /**
     * «Показ» оффера — один на результат (эпоху контекста) и состояние, и
     * только когда у карточки есть коробка.
     *
     * ⚠️ Раньше событие уходило на КАЖДУЮ отрисовку: карточка, которая ждёт
     * результата в скрытом «доме» тула, давала «показ» при загрузке страницы,
     * при объявлении обработчиков и при каждой смене контекста — сценарий
     * теста по алгебре насчитал 9 «показов» за один прогон, ни одного из них
     * человек не видел. Воронка «показ → оплата» делилась на мусор.
     */
    function shownOnce(host, st) {
        // Телеметрия никогда не ломает карточку: render зовёт это последним,
        // и исключение отсюда оставило бы человека без двери к покупке.
        try {
            var key = (host.__epoch || 0) + ':' + st.state;
            if (host.__shownKey === key) return;
            var fire = function () {
                if (host.__shownKey === key) return;
                host.__shownKey = key;
                ev(host, 'shown', { state: st.state, rub: st.price_rub || 0 });
            };
            if (host.__shownRO) { host.__shownRO.disconnect(); host.__shownRO = null; }
            if (hasBox(host) || typeof ResizeObserver !== 'function') { fire(); return; }
            // Скрыта (ждёт экрана результата) — показ наступит, когда появится коробка.
            var ro = host.__shownRO = new ResizeObserver(function () {
                if (!hasBox(host)) return;
                ro.disconnect();
                if (host.__shownRO === ro) host.__shownRO = null;
                var cur = host.__state;
                if (cur && ((host.__epoch || 0) + ':' + cur.state) === key) fire();
            });
            ro.observe(host);
        } catch (e) { /* без показа, но с карточкой */ }
    }

    /** Есть ли у карточки коробка. Нет способа спросить — считаем, что есть:
     *  лишний «показ» лучше потерянного. */
    function hasBox(host) {
        try { return typeof host.getClientRects !== 'function' || host.getClientRects().length > 0; }
        catch (e) { return true; }
    }

    /** Строка «купить за деньги» — ссылка, которую подхватывает token-wall.js. */
    function moneyLine(host, st, label) {
        var p = st.purpose || {};
        return '<a class="pg-second" href="' + esc(T(host, 'pricing_url') || '/pricing') + '"'
             + ' data-tmb-doc="' + esc(host.getAttribute('data-perk')) + '"'
             + ' data-tmb-doc-price="' + esc(st.price_rub) + '"'
             + ' data-tmb-title="' + esc(T(host, 'item', T(host, 'title'))) + '"'
             + ' data-tmb-purpose="' + esc(p.purpose || '') + '"'
             + ' data-tmb-purpose-ref="' + esc(p.purpose_ref || '') + '"'
             + ' data-tmb-purpose-token="' + esc(p.purpose_token || '') + '"'
             + ' data-tmb-purpose-kind="' + esc(p.purpose_kind || '') + '"'
             + ' data-tmb-purpose-locale="' + esc(p.purpose_locale || window.__LOCALE || '') + '"'
             + ' data-tmb-purpose-name="' + esc(p.purpose_name || '') + '"'
             + '>' + esc(fmt(label, { price: num(st.price_rub), item: T(host, 'item', T(host, 'title')) })) + '</a>';
    }

    function dateOf(iso) {
        try { return new Date(iso).toLocaleDateString(window.__LOCALE || 'ru', { day: 'numeric', month: 'long' }); }
        catch (e) { return String(iso).slice(0, 10); }
    }

    /* ── действия ────────────────────────────────────────────────────────── */

    function wire(host, st) {
        var h = HANDLERS[host.getAttribute('data-perk')] || {};

        var free = host.querySelector('[data-pg-free]');
        if (free) free.addEventListener('click', function () { issue(host, free, 'perk'); });

        var tok = host.querySelector('[data-pg-tokens]');
        if (tok) tok.addEventListener('click', function () { issue(host, tok, 'tokens'); });

        var prem = host.querySelector('[data-pg-premium]');
        // Последнее состояние, а не снимок отрисовки: назначение могло прийти
        // (armPark) или быть снято (новый результат) уже после неё.
        if (prem) prem.addEventListener('click', function () { openPremium(host, host.__state || st); });

        /* ⚠️⚠️ ПРОГОН ОТКЛАДЫВАЕТСЯ ПРИ ПЕРВОМ ПРИЗНАКЕ НАМЕРЕНИЯ — И НА
         * ВСЮ КАРТОЧКУ, а не только на денежную ссылку.
         *
         * Назначение платежа собирается из отложенного прогона, и без него
         * ЛЮБАЯ из дверей приводит человека к оплате, после которой выдавать
         * нечего. У денежной двери это было учтено сразу; у двери плана —
         * нет, и гость, нажавший «Открыть в Премиуме» не наведясь на строку
         * с ценой, уходил бы платить впустую. Поэтому слушаем карточку.
         *
         * ⚠️ Не на ПОКАЗ: показов оффера десятки тысяч в месяц, и строка на
         * каждый была бы мусором в таблице, а не воронкой. */
        if (h.park) {
            host.addEventListener('pointerdown', function () { armPark(host); }, true);
            host.addEventListener('focusin', function () { armPark(host); });
        }

        var money = host.querySelector('[data-tmb-doc]');
        if (money) {
            money.addEventListener('mouseenter', function () { armPark(host); }, true);
            money.addEventListener('click', function () { ev(host, 'money_click', { rub: st.price_rub }); });
        }
    }

    /**
     * Отложить прогон один раз и переписать назначение на живой разметке.
     *
     * Возвращает промис, чтобы дверь плана могла ПОДОЖДАТЬ: её ссылка несёт
     * назначение в адресе, и уйти раньше, чем оно готово, значит уйти без него.
     */
    function armPark(host) {
        if (host.__parking) return host.__parking;

        var h = HANDLERS[host.getAttribute('data-perk')] || {};
        if (!h.park) return Promise.resolve(null);

        /* ⚠️ Контекст могли сбросить, ПОКА прогон откладывался: новый результат
         * на той же странице (setContext с пустым контекстом). Ответ, пришедший
         * после сброса, описывает ПРЕЖНИЙ результат, и записанный в ссылку он
         * отдал бы кассе чужой номер. Поймано живым прогоном: под нагрузкой
         * откладывание шло 18 с, и номер первого результата лёг на денежную
         * строку пересчитанного. */
        var epoch = host.__epoch || 0;
        var stale = function () { return (host.__epoch || 0) !== epoch; };

        var mine = host.__parking = Promise.resolve(h.park()).then(function (ctx) {
            if (stale()) return null;
            if (!ctx || !ctx.ref) { host.__parking = null; return null; }
            host.__ctx = ctx;

            return fetchState(host).then(function (fresh) {
                if (!fresh || stale()) return null;
                host.__state = fresh;
                if (fresh.purpose) {
                    host.__purpose = fresh.purpose;
                    host.__purposeEpoch = epoch;
                }

                // Денежная ссылка читается token-wall'ом в момент нажатия —
                // обновляем её на месте, не перерисовывая карточку (перерисовка
                // сняла бы обработчики прямо под пальцем).
                var link = host.querySelector('[data-tmb-doc]');
                var p = fresh.purpose;
                if (link && p) {
                    link.setAttribute('data-tmb-purpose', p.purpose || '');
                    link.setAttribute('data-tmb-purpose-ref', p.purpose_ref || '');
                    link.setAttribute('data-tmb-purpose-token', p.purpose_token || '');
                    link.setAttribute('data-tmb-purpose-kind', p.purpose_kind || '');
                    link.setAttribute('data-tmb-purpose-name', p.purpose_name || '');
                }

                return fresh;
            });
        }).catch(function () { if (host.__parking === mine) host.__parking = null; return null; });

        return mine;
    }

    function issue(host, btn, via) {
        var h = HANDLERS[host.getAttribute('data-perk')];
        if (!h || !h.issue) return;

        btn.disabled = true;
        var prev = btn.textContent;
        btn.textContent = T(host, 'working', prev);
        ev(host, 'issue_start', { via: via });

        Promise.resolve(h.issue()).then(function (res) {
            if (res && res.ok !== false) {
                ev(host, 'issue_ok', { via: via });
                if (h.onIssued) h.onIssued(res);
                refresh(host);
                return;
            }
            ev(host, 'issue_fail', { via: via, why: (res && res.error) || 'unknown' });
            /* Отказ обязан ДОЙТИ: тихая кнопка — тот же класс, из-за которого
             * стена лимитов месяц отрабатывала по элементу с нулевой коробкой. */
            if (window.__toast) window.__toast(T(host, 'failed'), 'error');
            btn.disabled = false;
            btn.textContent = prev;
        }).catch(function () {
            ev(host, 'issue_fail', { via: via, why: 'exception' });
            if (window.__toast) window.__toast(T(host, 'failed'), 'error');
            btn.disabled = false;
            btn.textContent = prev;
        });
    }

    /* ── диалог плана ────────────────────────────────────────────────────── */

    function openPremium(host, st) {
        ev(host, 'premium_open', { rub: st.price_rub || 0 });

        /* Назначение может быть ещё не готово: откладывание прогона — запрос,
         * а нажатие мгновенно. Диалог рисуем сразу (ждать нечего и человеку
         * это видно), а ссылку плана дописываем, как только назначение придёт:
         * уйти в кассу без него значит заплатить и остаться без документа. */
        if (!st.purpose) {
            armPark(host).then(function (fresh) {
                if (!fresh || !fresh.purpose) return;
                var dlg = document.getElementById('pgDialog');
                var go  = dlg && dlg.querySelector('[data-pg-go]');
                if (go) go.setAttribute('href', premiumUrl(host, fresh));
            });
        }

        var dlg = document.getElementById('pgDialog');
        if (!dlg) {
            dlg = document.createElement('dialog');
            dlg.id = 'pgDialog';
            dlg.className = 'pg-dialog';
            document.body.appendChild(dlg);
        }

        var points = (T(host, 'plan_points') || '').split('|').filter(Boolean);
        var item   = T(host, 'item', T(host, 'title'));
        var html = '<form method="dialog" class="pg-dlg-x"><button aria-label="' + esc(T(host, 'close')) + '">×</button></form>'
                 + '<div class="pg-dlg-cap">' + esc(T(host, 'plan_name')) + '</div>'
                 + '<h3 class="pg-dlg-t">' + esc(fmt(T(host, 'modal_title'), { item: item })) + '</h3>'
                 + '<div class="pg-dlg-p">' + esc(T(host, 'plan_price')) + '</div>'
                 + '<ul class="pg-dlg-l"><li><b>' + esc(fmt(T(host, 'modal_first'), { item: item })) + '</b></li>'
                 + points.map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('')
                 + '</ul>'
                 + '<a class="pg-btn" href="' + esc(premiumUrl(host, st)) + '" data-pg-go>' + esc(T(host, 'modal_cta')) + '</a>';

        if (st.price_rub) {
            /* Тихая строка внизу: видно, но не спорит с кнопкой. Та самая
             * «не нарочито» — и при этом один клик, а не два. */
            html += '<div class="pg-dlg-rule"></div>'
                  + '<div class="pg-dlg-quiet"><span>' + esc(fmt(T(host, 'modal_only'), { item: item })) + '</span>'
                  + '<button type="button" data-pg-money>' + esc(fmt(T(host, 'modal_buy'), { price: num(st.price_rub) })) + '</button></div>';
        } else if (st.state === 'guest') {
            html += '<div class="pg-dlg-rule"></div>'
                  + '<div class="pg-dlg-quiet"><span>' + esc(fmt(T(host, 'have_premium'), { item: item })) + '</span>'
                  + '<a href="' + esc(T(host, 'login_url') || '/login') + '">' + esc(T(host, 'login')) + '</a></div>';
        }

        dlg.innerHTML = html;

        var go = dlg.querySelector('[data-pg-go]');
        if (go) go.addEventListener('click', function () { ev(host, 'premium_go', {}); });

        var money = dlg.querySelector('[data-pg-money]');
        if (money) {
            money.addEventListener('click', function () {
                ev(host, 'money_from_modal', { rub: st.price_rub });
                try { dlg.close(); } catch (e) { /* уже закрыт */ }
                /* Нажимаем СОБСТВЕННУЮ ссылку карточки: за ней уже висит
                 * token-wall со всей гостевой машинерией. Своя копия кассы
                 * здесь была бы вторым местом, где живут согласия. */
                var link = host.querySelector('[data-tmb-doc]');
                if (link) link.click();
            });
        }

        try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', 'open'); }
    }

    /** Ссылка на покупку плана — с назначением, чтобы документ выдался сам. */
    function premiumUrl(host, st) {
        var base = T(host, 'premium_url') || '/register';
        var p = st.purpose || {};
        if (!p.purpose_ref) return base;

        var q = (base.indexOf('?') === -1 ? '?' : '&')
              + 'purpose=' + encodeURIComponent(p.purpose || '')
              + '&purpose_ref=' + encodeURIComponent(p.purpose_ref)
              + '&purpose_token=' + encodeURIComponent(p.purpose_token || '')
              + '&purpose_kind=' + encodeURIComponent(p.purpose_kind || '')
              + '&purpose_locale=' + encodeURIComponent(p.purpose_locale || window.__LOCALE || '')
              + '&purpose_name=' + encodeURIComponent(p.purpose_name || '');
        return base + q;
    }

    /* ── внешний интерфейс ───────────────────────────────────────────────── */

    /**
     * Снять номер прежнего прогона с уже нарисованной карточки — СРАЗУ.
     *
     * Карточка перерисуется своим запросом состояния, но до его ответа (под
     * нагрузкой — секунды) её денежная строка и дверь плана отдали бы кассе
     * номер прошлого результата. Поймано живым прогоном: после пересчёта балла
     * по возрасту ссылка несла прогон прежнего балла.
     */
    function forgetPurpose(host) {
        var link = host.querySelector('[data-tmb-doc]');
        if (link) {
            ['ref', 'token', 'name'].forEach(function (k) { link.setAttribute('data-tmb-purpose-' + k, ''); });
        }
        if (host.__state) host.__state.purpose = null;
        host.__purpose = null;
    }

    function refresh(host) {
        /* Ответ, начатый до сброса контекста (см. setContext), несёт прежнее
         * назначение. Поверх свежего он не рисуется вовсе; пока свежего на
         * экране нет (ещё в пути или не удался — неудачный ответ прячет
         * карточку), рисуется БЕЗ назначения, а не выбрасывается: карточка без
         * назначения исправна, оно отложится заново при первом признаке
         * намерения. */
        var epoch = host.__epoch || 0;
        return fetchState(host).then(function (st) {
            if ((host.__epoch || 0) !== epoch) {
                if (host.__drawnEpoch === (host.__epoch || 0)) return st;
                if (st) st.purpose = null;
            }
            render(host, st);
            if (st) host.__drawnEpoch = epoch;
            return st;
        });
    }

    function mount(host) {
        if (!host || host.__pgMounted) return;
        host.__pgMounted = true;
        host.__ctx = {};
        HOSTS.push(host);
        refresh(host);
    }

    window.__perkGate = {
        /** Тул объявляет, как отложить прогон и как выдать документ. */
        register: function (perk, handlers) {
            HANDLERS[perk] = Object.assign(HANDLERS[perk] || {}, handlers || {});
            // Карточка могла смонтироваться раньше объявления — перерисуем,
            // чтобы подключились обработчики. Состояние уже пришло — из него,
            // без второго запроса (объявление делают на загрузке страницы).
            HOSTS.forEach(function (h) {
                if (h.getAttribute('data-perk') !== perk) return;
                if (h.__state && h.__drawnEpoch === (h.__epoch || 0)) render(h, h.__state);
                else refresh(h);
            });
        },
        /** Отложенный прогон появился/сменился — обновить назначение платежа. */
        setContext: function (perk, ctx) {
            HOSTS.forEach(function (h) {
                if (h.getAttribute('data-perk') !== perk) return;
                h.__ctx = ctx || {};
                /* Пустой контекст = НОВЫЙ результат на той же странице (тест
                 * прошли заново). Прежний отложенный прогон к нему не относится,
                 * и закэшированный промис откладывания отдал бы кассе ЧУЖОЙ
                 * номер прогона — человек заплатил бы за прошлую попытку. */
                if (!h.__ctx.ref) {
                    h.__parking = null;
                    h.__epoch = (h.__epoch || 0) + 1;
                    forgetPurpose(h);
                }
                refresh(h);
            });
        },
        refresh: function (perk) {
            HOSTS.forEach(function (h) {
                if (!perk || h.getAttribute('data-perk') === perk) refresh(h);
            });
        },
        state: function (perk) {
            var host = HOSTS.filter(function (h) { return h.getAttribute('data-perk') === perk; })[0];
            return host ? host.__state : null;
        },
        mount: mount
    };

    function scan() {
        Array.prototype.forEach.call(document.querySelectorAll('[data-perk-gate]'), mount);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scan);
    } else {
        scan();
    }
})();
